(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq"] && !Shopify.designMode) return;
  try {
      
  $(document).ready(function() {
    var $wrapper = $('.type-wrapper');

    // 默认第一个 .sub-item 加 active
    $wrapper.find('.sub-item').first().addClass('active');

    // 默认显示第一个 FAQ group
    var defaultGroup = $wrapper.find('.sub-item').first().data('type');
    $('.faq_answer_box .faq-group[data-group="' + defaultGroup + '"]').addClass('active');

    // 点击切换 active
    $wrapper.on('click', '.sub-item', function() {
      var $clicked = $(this);

      $wrapper.find('.sub-item').removeClass('active');
      $clicked.addClass('active');

      var type = $clicked.data('type');

      // FAQ group 切换 active
      $('.faq_answer_box .faq-group').removeClass('active');
      $('.faq_answer_box .faq-group[data-group="' + type + '"]').addClass('active');
    });

    /* ---------- 空状态提示 ---------- */
    // 当前分类没有对应 FAQ group，或 group 里没有可显示的问答时，显示提示，避免右侧一片空白
    var answerBox = document.querySelector('.faq_answer_box');

    if (answerBox) {
      var refreshFrame = null;
      var emptyState = answerBox.querySelector('.faq-empty-state');

      // 判断当前是否有可见的问答项（搜索过滤会把不匹配项置为 display:none）
      function hasVisibleAnswer() {
        var activeGroup = answerBox.querySelector('.faq-group.active');
        if (!activeGroup) return false;

        var items = activeGroup.querySelectorAll('.answer_item');
        for (var i = 0; i < items.length; i++) {
          if (items[i].style.display !== 'none') return true;
        }
        return false;
      }

      function refreshEmptyState() {
        if (!emptyState) return;

        var isEmpty = !hasVisibleAnswer();
        // 值没变就不写属性，避免触发自身再次回调
        if (answerBox.classList.contains('is-empty') !== isEmpty) {
          answerBox.classList.toggle('is-empty', isEmpty);
        }
      }

      // 分类切换、搜索高亮都会连续改动 class / 行内样式，合并到一帧里统一判断
      function scheduleRefresh() {
        if (refreshFrame) return;
        refreshFrame = window.requestAnimationFrame(function() {
          refreshFrame = null;
          refreshEmptyState();
        });
      }

      refreshEmptyState();

      // 分类切换来自本 section，搜索过滤来自 Faqs Navigation section，统一监听 answer_box 的变化
      new MutationObserver(scheduleRefresh).observe(answerBox, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        subtree: true,
        childList: true
      });
    }

    $('.category-title').on('click', function() {
      $('.category-container').toggleClass('active');
    });

    
    // var $header = $('header');
    // var $categoryContainer = $('.category-container');

    // // 更新 .category-container 的 top 位置
    // function updateCategoryPosition() {
    //   if (!$header.length || !$categoryContainer.length) return;

    //   // 获取 header 在当前视口中的位置信息
    //   var headerRect = $header[0].getBoundingClientRect();
    //   // 计算 header 的可见高度
    //   var headerHeight = Math.max(headerRect.height + headerRect.top, 0);
    //   // 把 .category-container 的 top 设置为 header 的可见高度
    //   $categoryContainer.css('top', headerHeight + 'px');
    // }

    // updateCategoryPosition();
    // $(window).on('scroll resize', updateCategoryPosition);

  });

  } catch(e) { console.error(e); }
})();
})();
